export default "__VITE_ASSET__DFu9T_k8__"